import MaterialSwitch, { SwitchProps } from "@mui/material/Switch";

interface Props extends SwitchProps {}

export const Switch = (props: Props) => {
  return <MaterialSwitch {...props} defaultChecked={true} />;
};
